<template lang="html">
<div>
  <v-parallax
    :src="require('../../assets/SocialGames/Header_SocialGames.png')"
    height="300"
    v-if="!mobile"
  >
    <v-container class="parallax-container-top">
      <v-layout justify-center align-center wrap>
        <v-flex xs12 sm10 md8 lg6>
          <h1 class="games-title">Social Games</h1>
          <p>We are proud to create social casino apps that are the best there is to offer.<br>
            Play for free and experience your favorite slot machines on your mobile<br>
            device with Lobstermania Slots&trade;, or Show Me Vegas Slots&trade;
          </p>
        </v-flex>
      </v-layout>
    </v-container>
  </v-parallax>
  <v-parallax
    :src="require('../../assets/SocialGames/Header_SocialGames.png')"
    height="200"
    v-else
  >
    <v-container class="parallax-container-top">
      <v-layout justify-center align-center wrap>
        <v-flex xs12 sm10 md8 lg6>
          <h1 class="games-title">Social Games</h1>
          <p>We are proud to create social casino apps that are the best there is to offer.<br>
            Play for free and experience your favorite slot machines on your mobile<br>
            device with Lobstermania Slots&trade;, or Show Me Vegas Slots&trade;
          </p>
        </v-flex>
      </v-layout>
    </v-container>
  </v-parallax>

  <!-- LMS -->
  <v-container fluid pa-0>
    <v-layout>
      <v-flex xs12>
        <v-img :src="require('../../assets/SocialGames/Background_LMS.png')">
          <div class="overall-container">
            <div class="banner-container">
              <v-img
                :src="lmsPhone"
                :max-height="700"
                :max-width="'100%'"
                contain
                :position="'center right'"
                id="lmsPhone"
              ></v-img>
              <v-container class="parallax-container px-0 more-styling">
                <v-layout>
                  <v-flex xs12 sm8 md6 lg5 xl4 class="text-xs-left">
                    <v-img
                      :src="lmsIcon"
                      :max-width="'30%'"
                      aspect-ratio="1"
                      contain
                      :position="'center left'"
                    ></v-img>
                    <h1 class="about-title text-xs-left">Lobstermania Slots<sup>&trade;</sup></h1>
                    <h4 class="about-subtitle text-xs-left">Winner Winner Lobster Dinner!</h4>

                    <v-flex xs12 sm12 md12 lg12 xl10>
                      <p class="body-text text-xs-left">Spin the reels to play "Lobstermania", "Stinkin' Rich Hot Poker Dice" &amp; all your favorite REAL VEGAS slot games; each packed with unique features, HUGE PAYOUTS & fun gameplay!</p>
                      <v-btn round large color="#f38120" style="color: white; font-weight: 1.5rem;" to="/lobstermania-slots">Learn More <v-icon>chevron_right</v-icon></v-btn>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </div>
        </v-img>
      </v-flex>
    </v-layout>
  </v-container>

  <!-- SMVS -->
  <v-container fluid pa-0>
    <v-layout>
      <v-flex xs12>
        <v-img :src="require('../../assets/SocialGames/Background_SMVS.png')">
          <div class="overall-container">
            <div class="banner-container">
              <!-- <img :src="require('../../assets/SocialGames/Phone_SMVS.png')" class="phone-smv" /> -->
              <v-img
                :src="smvPhone"
                :max-height="700"
                :max-width="'100%'"
                contain
                :position="'center right'"
                id="smvPhone"
              ></v-img>
              <v-container class="parallax-container px-0 more-styling">
                <v-layout>
                  <v-flex xs12 sm8 md6 lg5 xl4 class="text-xs-left">
                    <v-img
                      :src="smvIcon"
                      :max-width="'30%'"
                      aspect-ratio="1"
                      contain
                      :position="'center left'"
                    ></v-img>
                    <h1 class="about-title text-xs-left">Show Me Vegas Slots<sup>&trade;</sup></h1>
                    <h4 class="about-subtitle text-xs-left">Real Casino Slots, Real Excitement!</h4>

                    <v-flex xs12 sm12 md12 lg12 xl10>
                      <p class="body-text text-xs-left">Bring Las Vegas Home! &nbsp;Spin the reels and enjoy real Vegas casino slots like "Ghost Island", "Fishing Bob", "Super Sally's Shrimpmania"; all packed with unique features, HUGE PAYOUTS &amp; fun gameplay!</p>
                      <!-- <v-img
                        :src="smvButton"
                        @click="smvClick"
                        @mouseenter="changeButton"
                        @mouseleave="defaultButton"
                        id="smvBtn"
                      ></v-img> -->
                      <a href="https://showmevegasslots.onelink.me/uBTP?utm_source=ksg_web&utm_medium=website_click&utm_campaign=ksg_webtosmvsapp&utm_content=playforfreebutton&utm_term=all_users&pid=ksg_web&c=ksg_webtosmvsapp&af_dp=com.ksgmobileinc.showmevegasslotsv2" target="_blank" v-if="!mobile && !ipad">
                        <img :src="smvButton" id="pcBtn" alt="Show Me Vegas Play Button" style="width: 100%;" @mouseover="changeButton('pc-smvHover')" @mouseleave="defaultButton('pc-smvButton')" />
                      </a>
                      <a href="https://showmevegasslots.onelink.me/uBTP?utm_source=ksg_web&utm_medium=website_click&utm_campaign=ksg_webtosmvsapp&utm_content=playforfreebutton&utm_term=all_users&pid=ksg_web&c=ksg_webtosmvsapp&af_dp=com.ksgmobileinc.showmevegasslotsv2" target="_blank" v-else>
                        <img :src="smvButton" id="pcBtn" alt="Show Me Vegas Play Button" style="width: 100%;" @mouseover="changeButton('pc-smvHover')" @mouseleave="defaultButton('pc-smvButton')" />
                      </a>
                      <v-btn round large color="#f38120" style="color: white; font-weight: 1.5rem;" to="/show-me-vegas-slots">Learn More <v-icon>chevron_right</v-icon></v-btn>
                      <!-- margin: 0; -->
                    </v-flex>
                  </v-flex>
                </v-layout>

                <!-- <br>
                <v-flex xs12 sm10 md10 lg10 class="text-xs-left">
                </v-flex> -->
              </v-container>
            </div>
          </div>
        </v-img>
      </v-flex>
    </v-layout>
  </v-container>

  <!-- <v-container fluid pa-0>
    <v-layout>
      <v-flex xs12>
        <v-img :src="require('../../assets/SocialGames/Background_DSD.png')">
          <div class="overall-container">
            <div class="banner-container">
              <v-img
                :src="dsdPhone"
                :max-height="700"
                :max-width="'100%'"
                contain
                :position="'center right'"
              ></v-img>
              <v-container class="parallax-container px-0 more-styling">
                <v-layout>
                  <v-flex xs12 sm8 md6 lg5 xl4 class="text-xs-left">
                    <v-img
                      :src="dsdIcon"
                      :max-width="'30%'"
                      aspect-ratio="1"
                      contain
                      :position="'center left'"
                    ></v-img>
                    <h1 class="about-title text-xs-left">Ding Slots Ding!<sup>&trade;</sup></h1>
                    <h4 class="about-subtitle text-xs-left">A NEW Spin on Classic Slots!</h4>

                    <v-flex xs12 sm12 md12 lg12 xl10>
                      <p class="body-text text-xs-left">Viva Las Vegas! Welcome to the #1 hottest casino on Facebook and mobile. &nbsp;Spin and Win big for free. Ding Slots Ding delivers real, authentic, classic slot machine gaming with the biggest JACKPOT payouts!</p>
                      <a href="https://dingslotsding.onelink.me/EsB9?promoLink=3s9BpWKFc2UIIQaN&utm_source=KSGWebSite&utm_medium=ksg_website_web&utm_campaign=Persistent%2Cwebsite_connect%2CNULL%2CNULL&utm_content=NULLApp_Button&utm_term=G1%2CV0%2CNULL%2CR0%2C&af_dp=com.ksgmobileinc.dingslotsding%3A%2F%2F" target="_blank">
                        <img :src="smvButton" id="dsdBtn" alt="Ding Slots Ding Play Button" style="width: 100%;" @mouseover="changeButton('dsd-smvHover')" @mouseleave="defaultButton('dsd-smvButton')" />
                      </a>
                      <v-btn round large color="#f38120" style="color: white; font-weight: 1.5rem; margin: 0;" to="/ding-slots-ding">Learn More <v-icon>chevron_right</v-icon></v-btn>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </div>
        </v-img>
      </v-flex>
    </v-layout>
  </v-container> -->
</div>
</template>

<script>
export default {
  data () {
    return {
      smvIcon: require('../../assets/ShowMeVegasSlotsLogo.png'),
      smvButton: require('../../assets/buttons/Button_PlayForFreeEnabled.png'),
      smvHover: require('../../assets/buttons/Button_PlayForFreeOver.png'),
      dsdIcon: require('../../assets/Icon_DingSlotsDing.png'),
      smvPhone: require('../../assets/SocialGames/Phone_SMVS.png'),
      dsdPhone: require('../../assets/SocialGames/Phone_DSD.png'),
      lmsIcon: require('../../assets/LobsterManiaSlotsLogo.png'),
      lmsPhone: require('../../assets/SocialGames/Phone_LMS.png')
    }
  },
  computed: {
    mobile () {
      return navigator.userAgent.toLowerCase().indexOf('mobile') > -1 || navigator.userAgent.toLowerCase().indexOf('android') > -1
    },
    ipad () {
      return navigator.userAgent.toLowerCase().indexOf('ipad') > -1
    }
  },
  methods: {
    // smvClick () {
    //   window.open('https://showmevegasslots.onelink.me/uBTP?promoLink=UmMlkY2Q4dYjMkW7&utm_source=KSGWebSite&utm_medium=ksg_website_web&utm_campaign=Persistent%2Cwebsite_connect%2CNULL%2CNULL&utm_content=NULLApp_Button&utm_term=G1%2CV0%2CNULL%2CR0%2C&af_dp=com.ksgmobileinc.showmevegasslotsv2%3A%2F%2F', '_blank')
    // },
    changeButton (term) {
      let termArr = term.split('-')
      let platform = termArr[0]
      let el = document.querySelector(`#${platform}Btn`)
      let image = this[termArr[1]]
      el.src = image
      el.srcset = image
      // let el = document.querySelector(`#smvBtn div.v-image__image--cover`)
      // el.style.backgroundImage = 'url(' + this.smvHover + ')'
    },
    defaultButton (term) {
      let termArr = term.split('-')
      let platform = termArr[0]
      let el = document.querySelector(`#${platform}Btn`)
      let image = this[termArr[1]]
      el.src = image
      el.srcset = image
      // let el = document.querySelector(`#smvBtn div.v-image__image--cover`)
      // el.style.backgroundImage = 'url(' + this.smvButton + ')'
    }
    // dsdClick () {
    //   window.open('https://dingslotsding.onelink.me/EsB9?promoLink=3s9BpWKFc2UIIQaN&utm_source=KSGWebSite&utm_medium=ksg_website_web&utm_campaign=Persistent%2Cwebsite_connect%2CNULL%2CNULL&utm_content=NULLApp_Button&utm_term=G1%2CV0%2CNULL%2CR0%2C&af_dp=com.ksgmobileinc.dingslotsding%3A%2F%2F', '_blank')
    // },
    // dsdChangeButton () {
    //   let el = document.querySelector(`#dsdBtn div.v-image__image--cover`)
    //   el.style.backgroundImage = 'url(' + this.smvHover + ')'
    // },
    // dsdDefaultButton () {
    //   let el = document.querySelector(`#dsdBtn div.v-image__image--cover`)
    //   el.style.backgroundImage = 'url(' + this.smvButton + ')'
    // }
  }
}
</script>

<style lang="css" scoped>
.parallax-container-top {
  display: flex;
}

.games-title {
  font-size: 3rem;
}

.parallax-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
}

.overall-container {
  height: 100%;
}

.banner-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  height: 100%;
  padding: 1rem;
  grid-gap: 2rem;
}

.phone-smv {
  background-size: cover;
  display: grid;
  place-self: end;
  height: 90%;
  align-self: center;
}

.more-styling {
  /* width: 40%;
  margin: 0;
  margin-left: 2rem; */
  color: white;
}

.gameImg {
  /* width: 128px;
  height: 128px; */
}

#smvBtn {
  margin-left: -1rem;
}

#smvBtn:hover {
  cursor: pointer;
}

.about-title {
  font-size: 2.1rem;
  font-weight: 900;
  letter-spacing: -1px;
  /* margin-top: -2.5rem; */
  line-height: 99%;
  margin-bottom: 0.5rem;
}

.about-subtitle {
  /* font-weight: 800; */
  font-size: 1.3rem;
  line-height: 99%;
  margin-bottom: 1rem;
}

#dsdBtn {
  margin-left: -1rem;
}

#dsdBtn:hover {
  cursor: pointer;
}

sup {
  vertical-align: sub;
}
</style>
